module.exports = __webpack_public_path__ + "img/M351.ac65372e.jpg";